import React, { useEffect, useMemo } from 'react';
import Swal from 'sweetalert2';
import Home1 from './Home1';
import Home2 from './Home2';
import { useNavigate } from 'react-router-dom';

const Home = () => {

  const userRole = useMemo(() => {
    try {
      const user = JSON.parse(localStorage.getItem('userDetails'));
      return user?.data?.user?.role || null;
    } catch (err) {
      return null;
    }
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = localStorage.getItem('authToken');

    if (!userDetails) return;

    const updateShown = localStorage.getItem('newUpdateShown');

    if (updateShown) return;

    localStorage.setItem('newUpdateShown', 'true');
    const userinfo = JSON.parse(localStorage.getItem("userDetails"));
    const userName = userinfo?.data?.user?.name || "User";

    Swal.fire({
      title: `Welcome, ${userName}!`,

      html: `
        <div class="text-start">

            <!-- Header -->
            <div class="text-center mb-3">
               <span class="badge bg-info rounded-pill px-3 py-2  priority-badge mb-2">
    New Functionality
</span>

                <p class="text-muted small ">
                    You can now manage your profile information easily.
                </p>
            </div>

            <!-- Update Features -->
            <div class="border rounded-3">

                <!-- Profile Image -->
                <div class="d-flex align-items-start mb-2">
                    <div class="flex-shrink-0 text-info me-3">
                        <i class="fa fa-image fs-5"></i>
                    </div>

                    <div>
                        <h6 class="mb-1 fw-semibold">
                            Update Profile Image
                        </h6>

                        <p class="text-muted small mb-0">
                            Upload or update your profile picture.
                        </p>
                    </div>
                </div>

                <!-- Mobile Number -->
                <div class="d-flex align-items-start mb-2">
                    <div class="flex-shrink-0 text-success me-3">
                        <i class="fa fa-phone fs-5"></i>
                    </div>

                    <div>
                        <h6 class="mb-1 fw-semibold">
                            Update Mobile Number
                        </h6>

                       <p class="text-muted small mb-0">
    If you do not keep your registered mobile number updated, you may never be able to reset your password using the Forgot Password option.
</p>
                    </div>
                </div>

                <!-- Edit Profile -->
                <div class="d-flex align-items-start">
                    <div class="d-flex align-items-start mb-2">
                   <div class="flex-shrink-0 text-warning me-3">
                   <i class="fa fa-user fs-5"></i>
                  </div>
                 <div>
                       <h6 class="mb-1 fw-semibold">
                         Profile Information
                         </h6>

                       <p class="text-muted small mb-0">
                           Visit your profile details, including your current role,
                           account status, contact information, and total assigned stores.
                       </p>
                    </div>
              </div>
        </div>
        <small>
                <i class="fa fa-info-circle me-2"></i>
                    Keep your profile information up to date.
                </small>
    `,

      icon: "success",

      showCancelButton: true,

      confirmButtonText: `
        <i class="fa fa-external-link-alt me-1"></i>
        Visit Profile
    `,

      cancelButtonText: `
        <i class="fa fa-times me-1"></i>
        Close
    `,

      confirmButtonColor: "#20c9c3",
      cancelButtonColor: "#6c757d",

      width: "500px",

      allowOutsideClick: false,

      customClass: {
        popup: "rounded-2",
        title: "fw-semibold",
        confirmButton: "px-4 py-2 rounded-pill",
        cancelButton: "px-4 py-2 rounded-pill"
      }

    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/app-profile");
      }
    });
  }, []);


  const allowedRoles = ['storeKeeper', 'admin', 'superAdmin', 'director', 'pomaker', 'pochecker', 'accounts', 'billing'];

  return allowedRoles.includes(userRole) ? <Home2 /> : <Home1 />;


};

export default Home;